(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hc-city-collections"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const photos = new Map();
    const reset = (photo) => {
      photo.classList.remove('is-city-focusing');
      photo.style.removeProperty('--city-focus-x');
      photo.style.removeProperty('--city-focus-y');
    };
    const initialize = (root) => {
      root.querySelectorAll('.hc-city-collections__photo').forEach((photo) => {
        if (photos.has(photo)) return;
        const controller = new AbortController();
        photos.set(photo, controller);
        photo.addEventListener('pointermove', (event) => {
          if (!finePointer.matches || reducedMotion.matches || event.pointerType !== 'mouse') return;
          const rect = photo.getBoundingClientRect();
          const x = Math.max(30, Math.min(rect.width - 30, event.clientX - rect.left)) - rect.width / 2;
          const y = Math.max(30, Math.min(rect.height - 30, event.clientY - rect.top)) - rect.height / 2;
          photo.style.setProperty('--city-focus-x', `${x}px`);
          photo.style.setProperty('--city-focus-y', `${y}px`);
          photo.classList.add('is-city-focusing');
        }, { signal: controller.signal, passive: true });
        photo.addEventListener('pointerleave', () => reset(photo), { signal: controller.signal });
      });
    };
    const resetAll = () => photos.forEach((_, photo) => reset(photo));
    reducedMotion.addEventListener('change', resetAll);
    finePointer.addEventListener('change', resetAll);
    document.addEventListener('visibilitychange', () => { if (document.hidden) resetAll(); });
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      photos.forEach((controller, photo) => {
        if (event.target.contains(photo)) { controller.abort(); photos.delete(photo); }
      });
    });
    initialize(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-city-hero"] && !Shopify.designMode) return;
  try {
    
  function initCityCampaign(root = document) {
    root.querySelectorAll('[data-hc-city-hero]').forEach((hero) => {
      if (hero.dataset.ready) return;
      hero.dataset.ready = 'true';
      const button = hero.querySelector('[data-city-record]');
      const dialog = hero.querySelector('dialog');
      const video = hero.querySelector('[data-city-video]');
      const error = hero.querySelector('[data-city-error]');
      const frames = Array.from(hero.querySelectorAll('[data-city-frame]'));
      const marks = Array.from(hero.querySelectorAll('[data-city-mark]'));
      const count = hero.querySelector('[data-city-count]');
      const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
      let selected = Math.max(0, frames.findIndex((frame) => frame.classList.contains('is-current')));
      const activate = (index, commit = false) => {
        if (commit) selected = index;
        frames.forEach((frame, i) => {
          frame.classList.toggle('is-current', i === index);
          frame.setAttribute('aria-pressed', String(i === index));
          marks[i]?.classList.toggle('is-current', i === index);
        });
        count.textContent = String(index + 1).padStart(2, '0');
      };
      frames.forEach((frame, index) => {
        frame.addEventListener('pointerenter', (event) => { if (hover.matches && event.pointerType === 'mouse') activate(index); });
        frame.addEventListener('click', () => activate(index, true));
        frame.addEventListener('focus', () => activate(index, true));
        frame.addEventListener('keydown', (event) => {
          const next = { ArrowRight: (index + 1) % frames.length, ArrowLeft: (index + frames.length - 1) % frames.length, Home: 0, End: frames.length - 1 }[event.key];
          if (next === undefined) return;
          event.preventDefault();
          activate(next, true);
          frames[next].focus();
        });
      });
      hero.querySelector('.hc-city-hero__portraits').addEventListener('pointerleave', () => activate(selected));
      activate(selected);
      button.addEventListener('click', () => {
        error.hidden = true;
        dialog.showModal();
        video.play().catch(() => { error.hidden = false; });
      });
      hero.querySelector('[data-city-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => { video.pause(); button.focus({ preventScroll: true }); });
      video.addEventListener('error', () => { error.hidden = false; });
      document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); });
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(hero)) { video.pause(); dialog.close(); }
      });
    });
  }
  initCityCampaign();
  document.addEventListener('shopify:section:load', (event) => initCityCampaign(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-electric-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.hcErReady === 'true') return;
      root.dataset.hcErReady = 'true';
      const panels = Array.from(root.querySelectorAll('[data-hc-er-panel]'));
      const button = root.querySelector('[data-hc-er-flash]');

      const activatePanel = (selectedPanel) => {
        panels.forEach((panel) => {
          const isActive = panel === selectedPanel;
          panel.classList.toggle('is-active', isActive);
          panel.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      };

      panels.forEach((panel) => {
        panel.addEventListener('click', () => activatePanel(panel));
      });

      if (!button) return;
      let timer;
      button.addEventListener('click', () => {
        root.classList.remove('is-flashing');
        window.requestAnimationFrame(() => {
          root.classList.add('is-flashing');
          root.classList.toggle('is-charged');
          window.clearTimeout(timer);
          timer = window.setTimeout(() => root.classList.remove('is-flashing'), 650);
        });
      });
    };

    document.querySelectorAll('[data-hc-er-hero]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target.querySelector('[data-hc-er-hero]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-electric-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.hcErReady === 'true') return;
      root.dataset.hcErReady = 'true';
      root.querySelectorAll('[data-hc-er-story-flash]').forEach((button) => {
        button.addEventListener('click', () => root.classList.toggle('is-charged'));
      });
    };

    document.querySelectorAll('[data-hc-er-story]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target.querySelector('[data-hc-er-story]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-electric-world"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hc-proof]').forEach((proof) => {
    const tabs = Array.from(proof.querySelectorAll('[data-hc-proof-tab]'));
    const panels = Array.from(proof.querySelectorAll('[data-hc-proof-panel]'));

    const selectTab = (nextTab) => {
      const nextName = nextTab.dataset.hcProofTab;

      tabs.forEach((tab) => {
        const selected = tab === nextTab;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel.dataset.hcProofPanel !== nextName;
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectTab(tab));
      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const step = event.key === 'ArrowRight' ? 1 : -1;
        const nextTab = tabs[(index + step + tabs.length) % tabs.length];
        selectTab(nextTab);
        nextTab.focus();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-white-friday"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hc-white-friday')) {
  customElements.define('hc-white-friday', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.key = this.dataset.campaign;
      this.querySelectorAll('[data-hcwf-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
      this.querySelector('[data-hcwf-shop]').addEventListener('click', () => { this.remember(); this.dialog.close(); }, options);
      this.dialog.addEventListener('close', () => { this.remember(); this.unlock(); }, options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const stops = Array.from(this.dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]')).filter(el => el.getClientRects().length);
        const first = stops[0], last = stops[stops.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }, options);
      this.dialog.addEventListener('click', event => {
        const r = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) this.dialog.close();
      }, options);
      if (this.dataset.editor === 'true') { this.open(); return; }
      try { if (Date.now() - Number(localStorage.getItem(this.key) || 0) < Number(this.dataset.frequency) * 3600000) return; } catch {}
      this.deadline = Date.now() + 60000;
      this.timer = setTimeout(() => this.tryOpen(), Number(this.dataset.delay) * 1000);
    }
    tryOpen() {
      if (!this.isConnected || Date.now() > this.deadline) return;
      const blocked = document.hidden || Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"], .needsclick[role="dialog"], .thb-popup.modal-open')).some(el => el !== this.dialog && el.getClientRects().length > 0);
      if (blocked) { this.timer = setTimeout(() => this.tryOpen(), 1500); return; }
      this.open();
    }
    open() {
      if (this.dialog.open) return;
      this.previousOverflow = document.documentElement.style.overflow;
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      this.locked = true;
      if (this.dataset.editor !== 'true') {
        this.signupObserver = new MutationObserver(() => this.clearCompetingSignup());
        this.signupObserver.observe(document.body, { childList: true, subtree: true });
        this.signupInterval = setInterval(() => this.clearCompetingSignup(), 500);
        this.signupTimeout = setTimeout(() => { clearInterval(this.signupInterval); this.signupObserver?.disconnect(); }, 60000);
        this.clearCompetingSignup();
      }
      if (this.dataset.editor !== 'true') this.remember();
    }
    clearCompetingSignup() {
      document.querySelectorAll('[role="dialog"][aria-modal="true"] .klaviyo-close-form').forEach(button => {
        if (button.getClientRects().length) button.click();
      });
      if (this.dialog.open && !this.dialog.contains(document.activeElement)) this.querySelector('[data-hcwf-close]').focus({ preventScroll: true });
    }
    unlock() { if (this.locked) { document.documentElement.style.overflow = this.previousOverflow; this.locked = false; } }
    remember() { if (this.dataset.editor === 'true') return; try { localStorage.setItem(this.key, String(Date.now())); } catch {} }
    disconnectedCallback() { clearTimeout(this.timer); clearInterval(this.signupInterval); clearTimeout(this.signupTimeout); this.signupObserver?.disconnect(); if (this.dialog && this.dialog.open) this.dialog.close(); this.unlock(); this.abort?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
